import req from './http.js'

// 取得訂單列表
export const apiSearchTicketOrders = params => req('post', '/ticket_service/order/searchTicketOrders', params)

// 同步NS訂單
export const apiVerifyNSOrdSynced = params => req('post', '/ticket_service/order/verifyNSOrdSynced', params)

// 取消紙本票
export const apiCancelPaperTicket = params => req('post', '/ticket_service/order/cancelPaperTicket', params)

// 取消票
export const apiCancelTickets = params => req('post', '/ticket_service/order/cancelTickets', params)

// 取消TN票
export const apiCancelSpecialTickets = params => req('post', '/ticket_service/order/cancelSpecialTickets', params)

// 重啟取號
export const apiRestartFailedOrder = params => req('post', '/ticket_service/order/restartFailedOrder', params)

// 手動拋轉訂單到NS
export const apiReSyncExtOrdToNS = params => req('post', '/ticket_service/order/reSyncExtOrdToNS', params)

// 紙本票要號
export const apiProcessPaperTicketOrder = params => req('post', '/ticket_service/order/processPaperTicketOrder', params)

// 更新NS紙本票狀態
export const apiUpdatePaperTicketOrderNSStatus = params => req('post', '/ticket_service/order/updatePaperTicketOrderNSStatus', params)

// 作廢紙本票
export const apiBatchTrashPaperOrderTickets = params => req('post', '/ticket_service/order/batchTrashPaperOrderTickets', params)

// 新流程印紙本票
export const apiPrintPaperTicketPdf = params => req('post', '/ticket_service/order/printPaperTicketPdf', params)

// 取得所有QueueName
export const apiGetQueueNameList = params => req('get', '/queue/getQueueNameList', params)

// 取得所有Queue執行結果
export const apiGetQueueResultList = () => req('get', '/queue/getQueueResultList?queueName=printPaperTicketPdf')

// 取得單筆Queue執行結果
export const apiGetQueueResultListById = (queueId) => req('get', '/queue/getQueueResultListById?queueName=printPaperTicketPdf&queueId=' + queueId)

